module.exports = __webpack_public_path__ + "img/ad-logo.776dfc00.png";